<template>
  <div class="diario-mobile" v-loading="loading">
    <div v-show="showPrincipal">
      <div class="row row-custom diario-header">
        <div class="col-14 titolo no-padding">
          <span>{{ $t('diario.label.diario') }}</span>
        </div>
        <div class="col-10 action no-padding">
          <div class="add" v-if="enableAction('add')" @click="add">
            <icon name="riv-add_2" scale="2" class="pointer"></icon>
          </div>
          <div class="send" v-if="enableAction('sendAll')" @click="send()">
            <icon name="riv-sendMail" scale="2" class="pointer"></icon>
          </div>
        </div>
      </div>

      <el-table :data="diario" @row-click="open" class="el-table_mobile">
        <el-table-column header-align="center" align="center" width="30">


          <template slot-scope="scope" slot="header">
            <div class="icon-title" :key="scope.length">
              <el-popover placement="top" v-model="visibleInfo">
                <div>
                  <div>
                    <icon name="riv-circle" class="status-saved" scale="0.8"></icon>
                    <span>{{ $t('statusDett.0') }}</span>
                  </div>
                  <div>
                    <icon name="riv-circle" class="status-send" scale="0.8"></icon>
                    <span>{{ $t('statusDett.1') }}</span>
                  </div>
                  <div>
                    <icon name="riv-circle" class="status-rejected" scale="0.8"></icon>
                    <span>{{ $t('statusDett.2') }}</span>
                  </div>
                  <div>
                    <icon name="riv-circle" class="status-approved" scale="0.8"></icon>
                    <span>{{ $t('statusDett.3') }}</span>
                  </div>
                </div>

                <span slot="reference">
                  <icon class="pointer" name="riv-help" scale="1"></icon>
                </span>
              </el-popover>

            </div>
          </template>


          <template slot-scope="scope">
            <div class="data-wrapper">
              <el-tooltip class="item" effect="dark" :content="$t('statusDett.' + scope.row.statoAvanz)"
                placement="top-start">
                <icon :name="getStatoIcon_dett(scope.row.statoAvanz)" :class="getStatoClass_dett(scope.row.statoAvanz)"
                  scale="0.8"></icon>
              </el-tooltip>
            </div>
          </template>

        </el-table-column>
        <el-table-column header-align="center" align="center" :label="$t('diario.label.giorno')" width="100"
          class-name="sfondino">

          <template slot-scope="scope">
            <div class="name-wrapper">
              <span class="block">{{ scope.row.giorno | formattaData }}</span>
              <span class="block"> {{ scope.row.oraDal | formattaHours }} / {{ scope.row.oraAl | formattaHours }}</span>
            </div>
          </template>

        </el-table-column>

        <el-table-column header-align="desDest" align="center" :label="$t('diario.label.destinazione')">

          <template slot-scope="scope">
            <div class="name-wrapper truncate-overflow">
              {{ scope.row.desDest }}
            </div>
          </template>

        </el-table-column>

        <el-table-column width="30">

          <template slot-scope="scope" slot="header">
            <div class="icon-title">
              <el-tooltip class="item" effect="dark" :content="$t('diario.label.mensa')" placement="top-start">
                <icon name="riv-mensa" scale="1.2"></icon>
              </el-tooltip>
            </div>
          </template>

          <template slot-scope="scope">
            <div class="data-wrapper">
              <el-tooltip v-if="scope.row.idMensa !== ''" class="item" effect="dark"
                :content="$t('statusDett.' + scope.row.statoMensa)" placement="top-start">
                <icon :name="getStatoIcon_dett(scope.row.statoMensa)" :class="getStatoClass_dett(scope.row.statoMensa)"
                  scale="0.8"></icon>
              </el-tooltip>
            </div>
          </template>
        </el-table-column>

        <el-table-column header-align="center" align="center" width="30">

          <template slot-scope="scope" slot="header">
            <div class="icon-title" :key="scope.length">
              <el-tooltip class="item" effect="dark" :content="$t('diario.label.alloggio')" placement="top-start">
                <icon name="riv-alloggio" scale="1.2"></icon>
              </el-tooltip>
            </div>
          </template>

          <template slot-scope="scope">
            <div class="data-wrapper">
              <el-tooltip v-if="scope.row.idAlloggio !== ''" class="item" effect="dark"
                :content="$t('statusDett.' + scope.row.statoAlloggio)" placement="top-start">
                <icon :name="getStatoIcon_dett(scope.row.statoAlloggio)"
                  :class="getStatoClass_dett(scope.row.statoAlloggio)" scale="0.8"></icon>
              </el-tooltip>
            </div>
          </template>
        </el-table-column>

        <el-table-column header-align="center" align="center" width="30">

          <template slot-scope="scope">
            <div class="name-wrapper" :key="scope.length" @click.stop.prevent
              v-if="enableAction('send', scope.row) || enableAction('del')">
              <el-tooltip placement="left" popper-class="popover-mobile" effect="light">
                <template slot="content">
                  <div @click="send(scope.row)" v-if="enableAction('send', scope.row)">
                    <span>{{ $t('diario.label.send') }}</span>
                  </div>
                  <div @click="del(scope.row)" v-if="enableAction('del')">
                    <span>{{ $t('diario.label.delete') }}</span>
                  </div>
                </template>

                <icon class="pointer action" name="riv-more" scale="1.5"></icon>
              </el-tooltip>
            </div>
          </template>
        </el-table-column>

        <!--<el-table-column
          width="50">

          <template slot-scope="scope">
            <div class="data-wrapper">
              <icon name="riv-sendMail" scale="1.2" @click.native.stop="send(scope.row)"
                    v-if="enableAction('send',scope.row)"></icon>
            </div>
          </template>
        </el-table-column>

        <el-table-column
          width="50"
          v-if="enableAction('del')">

          <template slot-scope="scope">
            <div class="data-wrapper">
              <icon name="riv-delete2" scale="1.2" @click.native.stop="del(scope.row)"></icon>
            </div>
          </template>
        </el-table-column>-->
      </el-table>

      <el-pagination v-if="(nrPages > 1)" :current-page="currentPage" background layout="prev, pager, next"
        :total="nrItems" :page-size="pag_for" @current-change="changePage" class="el-pagination_mobile" :pager-count=5>
      </el-pagination>
    </div>

    <!-- Dialog di creazione -->
    <div v-show="showModal" class="el-form_mobile">

      <div class="el-form-header row row-custom">
        <div class="el-form-action col-2 no-padding">
          <icon name="riv-arrow2" scale="1.2" flip="horizontal" @click.native="closeModal('showModal')"></icon>
        </div>
        <div class="el-form-title col-20 no-padding">
          {{ $t('diario.label.diario').toUpperCase() }}
        </div>
      </div>

      <el-form class="el-form-body" :disabled="formDisabled">
        <div class="elemento row row-custom"
          :class="[!this.validaDiario && (this.form.giorno === undefined || this.form.giorno === null) ? 'row-error' : '']">
          <div class="el-form-label col-24 no-padding">{{ $t('diario.label.giorno') + ' (*)' }}</div>
          <div class="el-form-input col-24 no-padding">
            <div class="input-wrapper">
              <input type="date" v-model="form.giorno" class="first" :disabled="formDisabled || form.id != ''"
                :class="formDisabled || form.id != '' ? 'field-disabled' : ''" />

              <!--<el-date-picker class="dt-picker"
                              v-model="form.giorno"
                              type="date" format="dd/MM/yyyy" value-format="yyyyMMdd"
                              placeholder=""
                              :disabled="form.id != ''">
              </el-date-picker>-->
            </div>
          </div>
        </div>
        <div class="elemento row row-custom"
          :class="[!this.validaDiario && (this.form.oraDal === undefined || this.form.oraDal === null || this.form.oraAl === undefined || this.form.oraAl === null) ? 'row-error' : '']">
          <div class="el-form-label col-24 no-padding">{{ $t('diario.label.orario') + ' (*)' }}</div>
          <div class="el-form-input col-12 padding-right">
            <div class="input-wrapper">
              <input type="time" v-model="form.oraDal" class="first" :disabled="formDisabled || form.id != ''"
                :class="formDisabled || form.id != '' ? 'field-disabled' : ''" />
              <!--<el-time-picker
              v-model="form.oraDal"
              format="HH:mm"
              :placeholder="$t('diario.label.inizio')"
              value-format="HH:mm"
              :disabled="form.id != ''">
            </el-time-picker>-->
            </div>
          </div>
          <div class="el-form-input col-12 padding-left">
            <div class="input-wrapper">
              <input type="time" v-model="form.oraAl" class="first" :disabled="formDisabled || form.id != ''"
                :class="formDisabled || form.id != '' ? 'field-disabled' : ''" />
              <!--el-time-picker
                v-model="form.oraAl"
                format="HH:mm"
                :placeholder="$t('diario.label.fine')"
                value-format="HH:mm"
                :disabled="form.id != ''">
              </el-time-picker>-->
            </div>
          </div>
        </div>
        <div class="elemento row row-custom"
          :class="[!this.validaDiario && (this.form.desCustom ? (this.form.desMan === undefined || this.form.desMan === '') : (this.form.destinazione === undefined || this.form.destinazione === '')) ? 'row-error' : '']">
          <div class="el-form-label col-12 no-padding">{{ $t('diario.label.destinazione') + ' (*)' }}</div>
          <div class="el-form-label col-12 no-padding">
            <el-switch v-model="form.desCustom" :active-text="$t('diario.label.altro')" active-color="#007c74">
            </el-switch>
          </div>

          <div class="el-form-input col-24 no-padding">
            <div class="select-wrapper" v-show="!form.desCustom">
              <select v-model="form.destinazione" :disabled="formDisabled"
                :class="formDisabled ? 'field-disabled' : ''">
                <option v-for="(item) in tbl_genSta" :value="item.id" :key="item.id">{{ item.desc }}</option>
              </select>
            </div>
            <div class="el-form-input col-24 no-padding" v-show="form.desCustom">
              <div class="input-wrapper">
                <input type="text" v-model="form.desMan" :disabled="formDisabled"
                  :class="formDisabled ? 'field-disabled' : ''"
                  :placeholder="[$t('diario.label.destinazioneCustom')]" />
              </div>
            </div>
          </div>
        </div>
        <div class="elemento row row-custom"
          :class="[!this.validaDiario && (this.form.socFat === undefined || this.form.socFat === '') ? 'row-error' : '']">
          <div class="el-form-label col-24 no-padding">{{ $t('diario.label.socFat') + ' (*)' }}</div>
          <div class="el-form-input col-24 no-padding">
            <div class="select-wrapper">
              <select v-model="form.socFat" @change="loadUffRep(form.socFat)" :disabled="formDisabled"
                :class="formDisabled ? 'field-disabled' : ''">
                <option v-for="(item) in tbl_socFat" :value="item.id" :key="item.id">{{ item.desc }}</option>
              </select>
            </div>
          </div>
        </div>
        <div class="elemento row row-custom"
          :class="[!this.validaDiario && (this.form.ufficio === undefined || this.form.ufficio === '') ? 'row-error' : '']">
          <div class="el-form-label col-24 no-padding">{{ $t('diario.label.uffRep') + ' (*)' }}</div>
          <div class="el-form-input col-24 no-padding">
            <div class="select-wrapper">
              <select v-model="form.ufficio" :disabled="formDisabled" :class="formDisabled ? 'field-disabled' : ''">
                <option v-for="(item) in tbl_uffRep" :value="item.id" :key="item.id">{{ item.desc }}</option>
              </select>
            </div>
          </div>
        </div>

        <div class="elemento row row-custom">
          <div class="el-form-label col-24 no-padding">{{ $t('diario.label.motivo') }}</div>
          <div class="el-form-input col-24 no-padding" style="height: 100%;">
            <div class="input-wrapper">
              <textarea v-model="form.motivo" class="first" rows="3" :disabled="formDisabled"
                :class="formDisabled ? 'field-disabled' : ''" />
            </div>
          </div>
        </div>

        <div class="elemento row row-custom">
          <div class="el-form-label col-24 no-padding">{{ $t('diario.label.note') }}</div>
          <div class="el-form-input col-24 no-padding" style="height: 100%;">
            <div class="input-wrapper">
              <textarea v-model="form.notaDip" class="first" rows="3" :disabled="formDisabled"
                :class="formDisabled ? 'field-disabled' : ''" />
            </div>
          </div>
        </div>

        <div class="elemento row row-custom">
          <div class="el-form-label col-22 no-padding">
            {{ $t('diario.label.mensa') }}
          </div>
          <div class="el-form-label col-2 no-padding">
            <el-checkbox v-model="form.checkedMensa" :indeterminate="false"></el-checkbox>
          </div>
          <div class="el-form-input col-24 no-padding" style="height: 100%;">
            <div class="input-wrapper">
              <textarea v-model="form.notaMensa" class="first" rows="3" :disabled="formDisabled || !form.checkedMensa"
                :class="formDisabled ? 'field-disabled' : ''" />
            </div>
          </div>
        </div>

        <div class="elemento row row-custom" v-if="trasferta.tipoTrasferta === 'GIO'">
          <div class="el-form-label col-22 no-padding">
            {{ $t('diario.label.alloggio') }}
          </div>
          <div class="el-form-label col-2 no-padding">
            <el-checkbox v-model="form.checkedAlloggio" :indeterminate="false"></el-checkbox>
          </div>
          <div class="el-form-input col-24 no-padding" style="height: 100%;">
            <div class="input-wrapper">
              <textarea v-model="form.notaAlloggio" class="first" rows="3"
                :disabled="formDisabled || !form.checkedAlloggio" :class="formDisabled ? 'field-disabled' : ''" />
            </div>
          </div>
        </div>


        <div v-if="form.statoAvanz !== '0' && form.statoAvanz !== undefined">
          <div class="elemento row row-custom">
            <div class="my-area col-24 no-padding">
              {{ $t('diario.label.segreteria') }}
            </div>
          </div>
          <div class="elemento row row-custom" v-if="form.descrTipo !== '' || form.nomeHotel !== ''">
            <div class="el-form-label col-24 no-padding">
              {{ form.descrTipo }}
            </div>
            <div class="el-form-value col-24 no-padding">
              {{ form.nomeHotel }}
            </div>
          </div>
          <div class="elemento row row-custom" v-if="form.indirizzo !== ''">
            <div class="el-form-label col-24 no-padding">
              {{ $t('diario.label.indirizzo') }}
            </div>
            <div class="el-form-value col-24 no-paddin">
              {{ form.indirizzo }}
            </div>
          </div>
          <div class="elemento row row-custom" v-if="form.numeroCamera !== ''">
            <div class="el-form-label col-24 no-padding">
              {{ $t('diario.label.room') }}
            </div>
            <div class="el-form-value col-24 no-padding">
              {{ form.numeroCamera }}
            </div>
          </div>
          <div class="elemento row row-custom" v-if="form.notaSegAlloggio !== ''">
            <div class="el-form-label col-24 no-padding">
              {{ $t('diario.label.noteSegreteriaAlloggio') }}
            </div>
            <div class="el-form-value col-24 no-paddin">
              {{ form.notaSegAlloggio }}
            </div>
          </div>
          <div class="elemento row row-custom" v-if="form.notaSegMensa !== ''">
            <div class="el-form-label col-24 no-padding">
              {{ $t('diario.label.noteSegreteriaMensa') }}
            </div>
            <div class="el-form-value col-24 no-paddin">
              {{ form.notaSegMensa }}
            </div>
          </div>
          <div v-if="form.nomeFile !== ''" class="elemento row row-custom">
            <div @click="getDoc(form.nomeFile)">
              <icon name="riv-download" scale="1.5"></icon>
              <span class="truncate applicazione">{{ form.nomeFile }}</span>
            </div>
          </div>
        </div>

      </el-form>

      <span slot="footer" class="">
        <el-button class="mobile-el-button primary" v-if="!formDisabled" @click="checkSave()">{{ $t('btn.salva')
          }}</el-button>
        <el-button class="mobile-el-button secondary" v-if="formDisabled" @click="closeModal('showModal')">{{
          $t('btn.close')
          }}</el-button>
        <el-button class="mobile-el-button secondary" v-if="!formDisabled" @click="closeModal('showModal')">{{
          $t('btn.annulla') }}</el-button>
      </span>

      <!--</el-dialog>-->
    </div>
  </div>
</template>

<script>
import moment from 'moment'

export default {
  name: 'DiarioMobile',
  props: ['trasferta', 'tbl_genSta', 'tbl_socFat'],
  i18n: {
    messages: {
      it_IT: {
        diario: {
          label: {
            giorno: 'Giorno',
            orario: 'Orario',
            destinazione: 'Destinazione',
            destinazioneCustom: 'Altra Destinazione',
            altro: 'Altro',
            mensa: 'Mensa',
            alloggio: 'Alloggio',
            diario: 'Diario di Viaggio',
            socFat: 'Soc. di Fatturazione',
            uffRep: 'Ufficio/Reparto',
            motivo: 'Motivo',
            note: 'Nota',
            segreteria: 'Segreteria',
            indirizzo: 'Indirizzo',
            room: 'N° Camera',
            noteSegreteria: 'Note Segreteria',
            noteSegreteriaAlloggio: 'Note Segr. Alloggio',
            noteSegreteriaMensa: 'Note Segr. Mensa',
            inizio: 'Inizio',
            fine: 'Fine',
            send: 'Invia',
            delete: 'Elimina'
          },
          msg: {
            saveMensa: 'Salvataggio Mensa',
            saveAlloggio: 'Salvataggio Alloggio',
            datiObbligatoriMancanti: 'Dati obbligatori mancanti'
          }
        }
      },
      fr_FR: {
        diario: {
          label: {
            giorno: 'Jour',
            orario: 'Horaire',
            destinazione: 'Destination',
            destinazioneCustom: 'Autre  Destination',
            altro: 'Autre',
            mensa: 'Repas',
            alloggio: 'Hébergement',
            diario: 'Détail du voyage',
            socFat: 'Société de facturation',
            uffRep: 'Bureau/département',
            motivo: 'Motif',
            note: 'Notes',
            segreteria: 'Secrétaire',
            indirizzo: 'Adresse',
            room: 'N° de chambre',
            noteSegreteria: 'Annotations de la Secrétaire',
            noteSegreteriaAlloggio: 'Annot. Sécr. S/Logement',
            noteSegreteriaMensa: 'Annot. Sécr. S/Repas',
            inizio: 'de',
            fine: 'à',
            send: 'Envoyer',
            delete: 'Supprimer'
          },
          msg: {
            saveMensa: 'Sauvegarder Repas',
            saveAlloggio: 'Sauvegarder Hébergement',
            datiObbligatoriMancanti: 'Données obligatoires manquantes'
          }
        }
      },
      es_ES: {
        diario: {
          label: {
            giorno: 'Día',
            orario: 'Horas',
            destinazione: 'Destino',
            destinazioneCustom: 'Otro Destino',
            altro: 'Otro',
            mensa: 'Comedor',
            alloggio: 'Alojamiento',
            diario: 'Agenda de viaje',
            socFat: 'Sociedad de facturación',
            uffRep: 'Oficina/Empresa',
            motivo: 'Referencia',
            note: 'Nota',
            segreteria: 'Secretaria',
            indirizzo: 'Dirección',
            room: 'Habitación',
            noteSegreteria: 'Nota de la Secretaria',
            noteSegreteriaAlloggio: 'Nota Secr. Alojamiento',
            noteSegreteriaMensa: 'Nota Secr. Comedor',
            inizio: 'de',
            fine: 'a',
            send: 'Enviar',
            delete: 'Borrar'
          },
          msg: {
            saveMensa: 'Comida guardada',
            saveAlloggio: 'Alojamiento guardado',
            datiObbligatoriMancanti: 'Faltan datos obligatorios'
          }
        }
      },
      de_DE: {
        diario: {
          label: {
            giorno: 'Tag',
            orario: 'Zeitraum',
            destinazione: 'Reiseziel',
            destinazioneCustom: 'Anderes Destination',
            altro: 'Autre',
            mensa: 'Kantine',
            alloggio: 'Unterkunft',
            diario: 'Reiseplan',
            socFat: 'Rechnungsfirma',
            uffRep: 'Büro/Abteilung',
            motivo: 'Grund',
            note: 'Notiz',
            segreteria: 'Sekretariat',
            indirizzo: 'Adresse',
            room: 'Zimmer',
            noteSegreteria: 'Notiz des Sekretariat',
            noteSegreteriaAlloggio: 'Notiz des Sekretariat Unterkunft',
            noteSegreteriaMensa: 'Notiz des Sekretariat Kantine',
            inizio: 'Start',
            fine: 'Ende',
            send: 'Senden',
            delete: 'Löschen'
          },
          msg: {
            saveMensa: 'Kantine retten',
            saveAlloggio: 'Unterkunft sparen',
            datiObbligatoriMancanti: 'Fehlende Pflichtangaben'
          }
        }
      },
      en_GB: {
        diario: {}
      }
    }
  },
  data() {
    return {
      showPrincipal: true,
      visibleInfo: false,
      loading: false,
      diario: [],
      currentPage: 1,
      pag_for: 8,
      pag_order: 'DD',
      nrPages: 0,
      nrItems: 0,
      showModal: false,
      form: {},
      tbl_uffRep: [],
      formDisabled: false,
      validaDiario: true,
      daInoltrare: '0'
    }
  },
  filters: {
    /* Formatta la data: GGMMAAAA --> GG/MM/AAAA */
    formattaData: function (date) {
      if (date !== '') {
        return date.substr(6, 2) + '/' + date.substr(4, 2) + '/' + date.substr(0, 4)
      } else {
        return ' '
      }
    },
    formattaHours: function (hours) {
      if (hours !== '') {
        return hours.replace(',', ':')
      } else {
        return ' '
      }
    }
  },
  beforeMount: function () {
    this.formDisabled = this.trasferta.terminata === 'T' ? true : false
    this.loadDiario()
  },
  mounted: function () {
  },
  methods: {
    loadDiario: function () {
      this.$set(this, 'diario', [])
      this.loading = true
      this.$http.get('trasferte/' + this.$store.state.country + '/diario', {
        params: {
          idTrasferta: this.trasferta.idTrasferta,
          pag_action: (this.currentPage > 1) ? 'NEXT' : 'BEGIN',
          pag_from: this.currentPage,
          pag_for: this.pag_for,
          pag_order: this.pag_order
        }
      })
        .then(response => {
          if (response.body.rc === 0) {
            this.diario = response.body.data
            if (this.currentPage === 1) {
              this.$set(this, 'nrPages', parseInt(response.body.attrib.pages))
              this.$set(this, 'nrItems', parseInt(response.body.attrib.size))
              this.$set(this, 'daInoltrare', response.body.attrib.daInoltrare)
            }
          } else {
            this.$message({
              showClose: true,
              message: response.body.msg[0].msgTxt,
              type: 'error',
              duration: process.env.duration
            })
            this.$set(this, 'diario', [])
            this.$set(this, 'nrPages', 0)
            this.$set(this, 'nrItems', 0)
          }
          this.loading = false
        })
    },
    add: function () {
      this.validaDiario = true
      this.$set(this, 'form', {})
      this.$set(this.form, 'giorno', moment(this.trasferta.dataDal, "YYYYMMDD").format("YYYY-MM-DD"))
      this.$set(this.form, 'destinazione', this.trasferta.destinazione)
      this.$set(this.form, 'motivo', this.trasferta.notaDip.split("\\n").join("\n"))
      this.$set(this.form, 'desCustom', (this.trasferta.desMan === '' || this.trasferta.desMan === undefined) ? false : true)
      this.$set(this.form, 'desMan', this.trasferta.desMan)
      this.$set(this.form, 'checkedMensa', false)
      this.$set(this.form, 'statoMensa', "0")
      this.$set(this.form, 'checkedAlloggio', false)
      this.$set(this.form, 'statoAlloggio', "0")
      this.form.id = ''
      this.form.idMensa = ''
      this.form.idAlloggio = ''
      this.form.idTrasferta = this.trasferta.idTrasferta
      this.openModal("showModal")
    },
    open: function (row, event, column) {
      this.validaDiario = true
      this.$set(this, 'form', {})
      this.loadUffRep(row.socFat)
      this.form.idTrasferta = row.idTrasferta
      this.form.id = row.id
      this.form.statoAvanz = row.statoAvanz
      this.$set(this.form, 'giorno', moment(row.giorno, "YYYYMMDD").format("YYYY-MM-DD"))
      this.$set(this.form, 'oraDal', moment(row.oraDal, 'HH,mm').format('HH:mm'))
      this.$set(this.form, 'oraAl', moment(row.oraAl, 'HH,mm').format('HH:mm'))
      this.$set(this.form, 'destinazione', row.desCustom === '1' ? '' : row.destinazione)
      this.$set(this.form, 'desMan', row.desCustom === '1' ? row.destinazione : '')
      this.$set(this.form, 'desCustom', row.desCustom === '1' ? true : false)
      this.$set(this.form, 'socFat', row.socFat)
      this.$set(this.form, 'ufficio', row.ufficio)
      this.$set(this.form, 'motivo', row.motivo.split("\\n").join("\n"))
      this.$set(this.form, 'notaDip', row.notaDip.split("\\n").join("\n"))
      this.$set(this.form, 'desCustom', row.desCustom === '1' ? true : false)
      if (row.idAlloggio != '') {
        this.$set(this.form, 'checkedAlloggio', true)
        //this.form.checkedAlloggio = true
      } else {
        this.$set(this.form, 'checkedAlloggio', false)
        this.$set(this.form, 'statoAlloggio', "0")
      }
      if (row.idMensa != '') {
        this.$set(this.form, 'checkedMensa', true)
        //this.form.checkedMensa = true
      } else {
        this.$set(this.form, 'checkedMensa', false)
        this.$set(this.form, 'statoMensa', "0")
      }
      this.form.idAlloggio = row.idAlloggio
      this.form.idMensa = row.idMensa
      this.$set(this.form, 'notaAlloggio', '')
      this.$set(this.form, 'notaMensa', '')
      if (this.form.idAlloggio === '' && this.form.idMensa === '') {
        this.openModal("showModal")
      } else {
        this.loadDettaglio(row.id, row.idAlloggio, row.idMensa)
      }
    },
    checkSave: function () {
      this.validaDiario = true
      if (this.form.giorno === null || this.form.giorno === undefined) {
        this.validaDiario = false
      }
      if (this.form.oraDal === null || this.form.oraDal === undefined) {
        this.validaDiario = false
      }
      if (this.form.oraAl === null || this.form.oraAl === undefined) {
        this.validaDiario = false
      }
      if (this.form.desCustom) {
        if (this.form.desMan === '' || this.form.desMan === undefined) {
          this.validaDiario = false
        }
      } else {
        if (this.form.destinazione === '' || this.form.destinazione === undefined) {
          this.validaDiario = false
        }
      }
      if (this.form.socFat === '' || this.form.socFat === undefined) {
        this.validaDiario = false
      }
      if (this.form.ufficio === '' || this.form.ufficio === undefined) {
        this.validaDiario = false
      }

      if (this.validaDiario) {
        this.save()
      } else {
        this.$message.error(this.$i18n.t('diario.msg.datiObbligatoriMancanti'))
      }
    },
    save: function () {
      let _this = this
      this.loading = true
      let opMensa = ''
      if (this.form.idMensa === '' && this.form.checkedMensa) {
        opMensa = '*ADD'
      } else if (this.form.id != '' && this.form.idMensa != '' && !this.form.checkedMensa) {
        opMensa = '*DEL'
      } else if (this.form.id != '' && this.form.idMensa != '' && this.form.checkedMensa) {
        opMensa = '*UPD'
      }
      let opAlloggio = ''
      if (this.form.idAlloggio === '' && this.form.checkedAlloggio) {
        opAlloggio = '*ADD'
      } else if (this.form.id != '' && this.form.idAlloggio != '' && !this.form.checkedAlloggio) {
        opAlloggio = '*DEL'
      } else if (this.form.id != '' && this.form.idAlloggio != '' && this.form.checkedAlloggio) {
        opAlloggio = '*UPD'
      }
      let objMensa = {
        'id': this.form.id === '' ? '' : this.form.idMensa,
        'operazione': opMensa,
        'tipo': 'P',
        'notaDip': this.form.notaMensa,
        'giorno': moment(this.form.giorno, 'YYYY-MM-DD').format('YYYYMMDD'),
        'statoAvanz': this.form.statoMensa
      }
      let objAlloggio = {
        'id': this.form.id === '' ? '' : this.form.idAlloggio,
        'operazione': opAlloggio,
        'notaDip': this.form.notaAlloggio,
        'giorno': moment(this.form.giorno, 'YYYY-MM-DD').format('YYYYMMDD'),
        'statoAvanz': this.form.statoAlloggio
      }
      let obj = {
        'idTrasferta': this.form.idTrasferta,
        'id': this.form.id === '' ? '' : this.form.id,
        'operazione': this.form.id === '' ? '*ADD' : '*UPD',
        'giorno': moment(this.form.giorno, 'YYYY-MM-DD').format('YYYYMMDD'),
        'oraDal': moment(this.form.oraDal, 'HH:mm').format('HH.mm.ss'),
        'oraAl': moment(this.form.oraAl, 'HH:mm').format('HH.mm.ss'),
        'destinazione': this.form.desCustom ? this.form.desMan : this.form.destinazione,
        'ufficio': this.form.ufficio,
        'socFat': this.form.socFat,
        'motivo': this.form.motivo,
        'notaDip': this.form.notaDip,
        'mensa': objMensa,
        'alloggio': objAlloggio
      }
      if (this.form.id != '') {
        delete obj['oraDal']
        delete obj['oraAl']
      }
      if (opMensa === '') {
        delete obj['mensa']
      }
      if (opAlloggio === '') {
        delete obj['alloggio']
      }
      this.$http.post('trasferte/' + this.$store.state.country + '/diario', obj)
        .then(response => {
          if (response.body.rc === 0) {
            this.$message({
              showClose: true,
              message: response.body.respDiario.msg[0].msgTxt,
              type: 'success',
              duration: process.env.duration
            })

            if (response.body.respMensa != undefined) {
              setTimeout(function () {
                // Notifico l'azione di salvataggio Alloggio
                //Notifico il salvataggio del giorno
                _this.$notify({
                  title: _this.$i18n.t('diario.msg.saveMensa'),
                  message: response.body.respMensa.msg[0].msgTxt,
                  type: response.body.respMensa.rc === 0 ? 'success' : 'error',
                  duration: process.env.duration
                })
              }, 400)
            }

            if (response.body.respAlloggio != undefined) {
              setTimeout(function () {
                // Notifico l'azione di salvataggio Alloggio
                //Notifico il salvataggio del giorno
                _this.$notify({
                  title: _this.$i18n.t('diario.msg.saveAlloggio'),
                  message: response.body.respAlloggio.msg[0].msgTxt,
                  type: response.body.respAlloggio.rc === 0 ? 'success' : 'error',
                  duration: process.env.duration
                })
              }, 800)
            }
            this.loadDiario()
            this.closeModal("showModal")
          } else {
            this.$message({
              showClose: true,
              message: response.body.msg[0].msgTxt,
              type: 'error',
              duration: process.env.duration
            })
          }
          this.loading = false
        })
    },
    del: function (row) {
      this.loading = true
      this.$http.delete('trasferte/' + this.$store.state.country + '/diario/' + row.idTrasferta + '/' + row.id)
        .then(response => {
          if (response.body.rc === 0) {
            this.$message({
              showClose: true,
              message: response.body.msg[0].msgTxt,
              type: 'success',
              duration: process.env.duration
            })
            this.loadDiario()
          } else {
            this.$message({
              showClose: true,
              message: response.body.msg[0].msgTxt,
              type: 'error',
              duration: process.env.duration
            })
          }
          this.loading = false
        })
    },
    send: function (row) {
      let obj = {}

      if (row != undefined) {
        obj = {
          idTrasferta: this.trasferta.idTrasferta,
          statoAvanz: '1',
          righeDiario: [{
            id: row.id
          }],
          numRigheDiario: 1
        }
      } else {
        obj = {
          idTrasferta: this.trasferta.idTrasferta,
          statoAvanz: '1',
          numRigheDiario: 0
        }
      }

      this.$http.post('trasferte/' + this.$store.state.country + '/statodiario', obj)
        .then(response => {
          if (response.body.rc === 0) {
            this.$message({
              showClose: true,
              message: response.body.msg[0].msgTxt,
              type: 'success',
              duration: process.env.duration
            })
            this.loadDiario()
          } else {
            this.$message({
              showClose: true,
              message: response.body.msg[0].msgTxt,
              type: 'error',
              duration: process.env.duration
            })
          }
        })
    },
    changePage: function (page) {
      this.currentPage = page
      this.loadDiario()
    },
    loadAlloggio: function (idRiga, id) {
      this.$http.get('trasferte/' + this.$store.state.country + '/alloggi', {
        params: {
          idTrasferta: this.trasferta.idTrasferta,
          id: id,
          idRiga: idRiga,
          pag_action: 'BEGIN',
          pag_from: 1,
          pag_for: 20,
          pag_order: 'DD'
        }
      }).then(response => {
        if (response.body.rc === 0) {
          this.form.notaAlloggio = response.body.data[0].notaDip
        } else {
          this.$message({
            showClose: true,
            message: response.body.msg[0].msgTxt,
            type: 'error',
            duration: process.env.duration
          })
        }
      })
    },
    loadDettaglio: function (idRiga, idAlloggio, idMensa) {
      this.loading = true
      this.$http.get('trasferte/' + this.$store.state.country + '/dettdiario', {
        params: {
          idTrasferta: this.trasferta.idTrasferta,
          idRiga: idRiga,
          idAlloggio: idAlloggio,
          idMensa: idMensa
        }
      }).then(response => {
        if (response.body.respAlloggio != undefined) {
          if (response.body.respAlloggio.rc === 0) {
            //this.form.notaAlloggio = response.body.respAlloggio.data[0].notaDip
            this.form.descrTipo = response.body.respAlloggio.data[0].descrTipo
            this.form.nomeHotel = response.body.respAlloggio.data[0].nomeHotel
            this.form.indirizzo = response.body.respAlloggio.data[0].indirizzo
            this.form.numeroCamera = response.body.respAlloggio.data[0].numeroCamera
            this.form.nomeFile = response.body.respAlloggio.data[0].nomeFile
            this.form.notaSegAlloggio = response.body.respAlloggio.data[0].notaSeg
            this.$set(this.form, 'notaAlloggio', response.body.respAlloggio.data[0].notaDip.split("\\n").join("\n"))
            this.form.statoAlloggio = response.body.respAlloggio.data[0].statoAvanz
          } else {
            this.$message({
              showClose: true,
              message: response.body.msg[0].msgTxt,
              type: 'error',
              duration: process.env.duration
            })
          }
        }
        if (response.body.respMensa != undefined) {
          if (response.body.respMensa.rc === 0) {
            this.form.notaMensa = response.body.respMensa.data[0].notaDip
            this.form.notaSegMensa = response.body.respMensa.data[0].notaSeg
            this.$set(this.form, 'notaMensa', response.body.respMensa.data[0].notaDip.split("\\n").join("\n"))
            this.form.statoMensa = response.body.respMensa.data[0].statoAvanz
          } else {
            this.$message({
              showClose: true,
              message: response.body.msg[0].msgTxt,
              type: 'error',
              duration: process.env.duration
            })
          }
        }
        this.loading = false
        this.openModal("showModal")
      })
    },
    loadMensa: function (idRiga, id) {
      this.$http.get('trasferte/' + this.$store.state.country + '/mensa', {
        params: {
          idTrasferta: this.trasferta.idTrasferta,
          id: id,
          idRiga: idRiga,
          pag_action: 'BEGIN',
          pag_from: 1,
          pag_for: 20,
          pag_order: 'DD'
        }
      }).then(response => {
        if (response.body.rc === 0) {
          this.form.notaMensa = response.body.data[0].notaDip
        } else {
          this.$message({
            showClose: true,
            message: response.body.msg[0].msgTxt,
            type: 'error',
            duration: process.env.duration
          })
        }
      })
    },
    loadUffRep: function (value, azione) {
      if (azione === 'S')
        value = event.target.value

      this.$http.get('datisoc/' + this.$store.state.country + '/uffrep', {
        params: {
          //cliente: value
          socFat: value
        }
      }).then(response => {
        if (response.body.rc === 0) {
          this.tbl_uffRep = response.body.data
          this.tbl_uffRep.unshift({ id: '', desc: ' ' })
        } else {
          this.$message({
            showClose: true,
            message: response.body.msg[0].msgTxt,
            type: 'error',
            duration: process.env.duration
          })
        }
        this.loading = false
      })
    },
    getDoc: function (nomeFile) {
      //let url = ('download/trasferta?fileName=' + nomeFile + '&country=' + this.$store.state.country + '&token=' + sessionStorage.getItem('token'))
      let url = ('download/document?codLang=' + sessionStorage.getItem('codLang') + '&delete=NO' +
        '&fileName=' + nomeFile + '&filePath=PaiCEDEXP' + '&token=' + sessionStorage.getItem('token'))
      let win = window.open(process.env.baseUrlSpring + url, '_blank')
      win.focus()
    },
    isDisabled: function () {
      if (this.trasferta.terminata === 'T' || this.form.id != '') {
        return true
      } else {
        return false
      }
    },
    enableAction: function (action, row) {
      let statoTrasferta = this.trasferta.statoAvanz
      if (this.trasferta.terminata === 'T') {
        return false
      }
      switch (action) {
        case 'send':
          if ((statoTrasferta === '1' || statoTrasferta === '3' || statoTrasferta === '4' || statoTrasferta === '5') && row.statoAvanz === '0') {
            return true
          } else {
            return false
          }
        case 'del':
          if (statoTrasferta === '0' || statoTrasferta === '1' || statoTrasferta === '3' || statoTrasferta === '4' || statoTrasferta === '5') {
            return true
          } else {
            return false
          }
        case 'sendAll':
          if (statoTrasferta === '1' || statoTrasferta === '3' || statoTrasferta === '4' || statoTrasferta === '6') {
            // Verifico se ho almeno 1 record modificato
            if (this.daInoltrare !== '0' && this.daInoltrare !== '') {
              // Abilito il pulsate perchè ho un record da inviare
              return true
            } else {
              // Ho già inviato tutto
              return false
            }
          } else {
            return false
          }
        case 'add':
          if (statoTrasferta === '0' || statoTrasferta === '1' || statoTrasferta === '3' || statoTrasferta === '4' || statoTrasferta === '6') {
            return true
          } else {
            return false
          }
      }
      return false
    },
    getStatoIcon_dett: function (stato) {
      switch (stato) {
        case '0':
        case '1':
        case '2':
        case '3':
        case '4':
          return 'riv-circle'
        default:
          return ''
      }
    },
    getStatoClass_dett: function (stato) {
      switch (stato) {
        case '0':
          return 'status-saved'
        case '1':
          return 'status-send'
        case '2':
          return 'status-rejected'
        case '3':
          return 'status-approved'
        case '4':
          return 'status-send'
        default:
          return ''
      }
    },
    openModal: function (field) {
      this.$set(this, field, true)
      this.$set(this, 'showPrincipal', false)
      this.$emit('showModalComponent', false)
    },
    closeModal: function (field) {
      this.$set(this, field, false)
      this.$set(this, 'showPrincipal', true)
      this.$emit('showModalComponent', true)
    }
  }
}
</script>

<style lang="less">
@import "../../assets/less/general.less";
@import "../../assets/less/mobile_customize.less";
@import "../../assets/less/el-table_mobile.less";
@import "../../assets/less/el-form_mobile.less";

/*.modal-dettaglio {
    .set-font();
    border-radius: 0px;
    .el-dialog__close {
      color: @greenRiva;
    }
    .el-dialog__header {
      padding: 7px 0px 2px 0px;
      border-bottom: 1px solid @greenRiva;
      width: 94%;
      line-height: 0px;
      margin: auto;
      .el-dialog__title {
        .set-font(@size: 14px; @weight: bold; @color: @greenRiva);
      }
      .el-dialog__headerbtn {
        top: 10px;
        right: 3%;
      }
    }
    .el-dialog__body {
      padding: 20px 20px;
      padding-right: 0px;
      padding-left: 0px;
      padding-bottom: 0px;
      margin: auto;
      width: 94%;
    }
    .form-dettaglio {
      margin-bottom: 20px;
      .modifica {
        margin-bottom: 40px !important;
      }
      .row-custom {
        margin-bottom: 10px;
        .my-area {
          height: 30px;
          border-bottom: 1px solid @textTable;
        }
        .my-label {
          height: 22px;
          line-height: 23px;
          .el-checkbox {
            float: right;
            margin-bottom: 0px;
            //margin-top: 10px;
            .el-checkbox__inner {
              border-radius: 0px;
            }
            &.is-checked {
              .el-checkbox__inner {
                background-color: @greenRiva;
                border-color: @greenRiva;
              }
            }
          }
        }
        .my-value {
          height: 100%;
          .dt-picker {
            width: 100%;
            .el-input__inner {
              padding-left: 30px !important;
            }
            .el-input__prefix {
              left: 0px;
              .el-input__icon {
                line-height: 22px;
                width: 17px;
              }
            }
            .el-input__suffix {
              .el-input__icon {
                line-height: 22px;
                width: 17px;
              }
            }
            &.time {
              width: 100px;
            }
          }
          .el-input {
            &.is-disabled {
              .el-input__inner {
                border: none;
              }
            }
            .el-input__inner {
              border: none;
              border-bottom: 1px solid #dcdfe6;
              border-radius: 0px;
              height: 22px;
              padding-left: 0px;
              line-height: 0px;
              .set-font(@size: 14px);
            }
            .el-input__suffix {
              .el-input__icon {
                line-height: 22px;
                width: 17px;
              }
            }
          }
          .el-select {
            height: 22px;
            width: 100%;
            .el-input {
              height: 22px;
              .el-input__inner {
                border: none;
                border-bottom: 1px solid #dcdfe6;
                border-radius: 0px;
                height: 22px !important;
                padding-left: 0px;
                .set-font(@size: 14px);
              }
            }
          }
          .el-textarea {
            .el-textarea__inner {
              border-radius: 0px;
              padding-left: 5px;
              line-height: 22px;
            }
            .el-textarea__inner:focus {
              border-color: @greenRiva;
            }
          }
        }
      }
    }
  }*/

.diario-mobile {
  // height: 100%;
  //min-width: 1250px;
  margin-bottom: 70px;
  max-width: 100%;

  .diario-header {
    height: 40px;
    margin-top: 10px;
    margin-bottom: 10px;

    .titolo {
      .set-font(@size: 16px, @color: @greenRiva, @family: "os-bold");
      text-align: left;
      line-height: 40px;
    }

    .action {
      text-align: right;
      line-height: 40px;

      .add {
        // position: fixed;
        // right: 20px;
        // bottom: 20px;
        float: right;
        color: #FF791A;
        margin-right: 10px;
        margin-left: 10px;
      }

      .send {
        // position: fixed;
        // right: 20px;
        // bottom: 20px;
        float: right;
        color: #FF791A;
        margin-right: 10px;
        margin-left: 10px;
      }
    }
  }

  .el-checkbox {
    margin-bottom: 0px;
    margin-top: 10px;

    .el-checkbox__inner {
      border-radius: 0px;
    }

    &.is-checked {
      .el-checkbox__inner {
        background-color: @greenRiva;
        border-color: @greenRiva;
      }
    }
  }

  /*.el-form_mobile {
      margin-bottom: 60px;
    }*/
  .row {
    &.row-error {
      .el-form-label {
        color: red !important;
      }
    }
  }
}

.popover-mobile {
  line-height: 50px;
  .set-font(@size: 18px, @color: @grayTesto, @family: "os-semibold")
}
</style>



// WEBPACK FOOTER //
// src/components/TrasferteMobile/DiarioMobile.vue